import { render, staticRenderFns } from "./acessControlDialog.vue?vue&type=template&id=d255cdca&scoped=true"
import script from "./acessControlDialog.vue?vue&type=script&lang=js"
export * from "./acessControlDialog.vue?vue&type=script&lang=js"
import style0 from "./acessControlDialog.vue?vue&type=style&index=0&id=d255cdca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d255cdca",
  null
  
)

export default component.exports